module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select_region":"Выберите регион"},"en":{"select_region":"Select region"}}')
  delete Component.options._Ctor
}
